import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@fontsource-variable/noto-sans-sc";
import "@fontsource-variable/space-grotesk";
import "./styles/global.css";
import { HomePage } from "./pages/HomePage";

const CandidatePage = lazy(() => import("./pages/CandidatePage").then((module) => ({ default: module.CandidatePage })));
const CandidateGuidePage = lazy(() => import("./pages/CandidateGuidePage").then((module) => ({ default: module.CandidateGuidePage })));
const ExaminerGuidePage = lazy(() => import("./pages/ExaminerGuidePage").then((module) => ({ default: module.ExaminerGuidePage })));
const LiveExaminersPage = lazy(() => import("./pages/LiveExaminersPage").then((module) => ({ default: module.LiveExaminersPage })));
const StaffLoginPage = lazy(() => import("./pages/StaffLoginPage").then((module) => ({ default: module.StaffLoginPage })));
const ChangePasswordPage = lazy(() => import("./pages/ChangePasswordPage").then((module) => ({ default: module.ChangePasswordPage })));
const ExaminerPage = lazy(() => import("./pages/ExaminerPage").then((module) => ({ default: module.ExaminerPage })));
const AdminPage = lazy(() => import("./pages/AdminPage").then((module) => ({ default: module.AdminPage })));

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={<div className="page-loading">正在加载页面…</div>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/candidate" element={<CandidatePage />} />
          <Route path="/candidate-guide" element={<CandidateGuidePage />} />
          <Route path="/examiner-guide" element={<ExaminerGuidePage />} />
          <Route path="/live-examiners" element={<LiveExaminersPage />} />
          <Route path="/examiner/login" element={<StaffLoginPage target="examiner" />} />
          <Route path="/staff/change-password" element={<ChangePasswordPage />} />
          <Route path="/examiner" element={<ExaminerPage />} />
          <Route path="/admin/login" element={<StaffLoginPage target="admin" />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);
